export default __webpack_public_path__ + "static/media/3-4-2.763f6cf2.jpg";